import * as React from 'react'
import { Widget, mk_widget, stateful, div } from 'widgets-for-react'
import { styleguideAbout } from './pages/about.mod'
import { styleguideGuidelines } from './pages/guidelines.mod'
import { styleguideTokens } from './pages/tokens.mod'
import { styleguideObjects } from './pages/objects.mod'
import { styleguideComponents } from './pages/components.mod'
import { styleguideCompositions } from './pages/compositions.mod'
import ReactDOM = require('react-dom')

export type StyleguideState = {
  page: 'about' | 'guidelines' | 'tokens' | 'objects' | 'components' | 'compositions'
}

const splitHash = () => {
  return window.location.hash.split('#')[1].split('-')[0]
}

const $breakpoint = 768

export let currentPage = window.location.hash ? splitHash() : 'about'
const apply_token_to_url = (token: string): void => {
  let address: string = window.location.href
  if (address.endsWith('/')) {
    address = address.slice(0, address.length - 1)
  }
  const tmp = address.split('#')
  window.location.href = tmp[0] + '#' + token
}
const __ = () => null

export const styleguide: Widget<never> = mk_widget({
  run: (refresh) => (
    <>
      <article className="styleguide">
        <div className="styleguide__main">
          <header className="styleguide__header">
            <div className="styleguide__brand styleguide--styled">
              <a className="styleguide__logo-link" href="/styleguide">
                <h1 className="sr-text">Styleguide Refresco</h1>
                <svg className="styleguide__logo"height="77" viewBox="0 0 227 77" width="227" xmlns="http://www.w3.org/2000/svg"><g fill="#fff"><path d="m226.3 29s-.8-.4-2.4-1c-1.6-.7-3.9-1.5-6.9-2.6-1.5-.5-3.1-1.1-5-1.7-1.8-.6-3.8-1.3-5.9-1.9-1.1-.3-2.1-.7-3.3-1-1.1-.3-2.3-.6-3.5-1-1.2-.3-2.4-.7-3.7-1s-2.5-.6-3.9-1c-1.3-.3-2.6-.7-4-1s-2.8-.6-4.2-.9-2.9-.6-4.3-1c-1.5-.3-3-.6-4.5-.8-1.5-.3-3.1-.6-4.6-.9-1.6-.2-3.1-.5-4.7-.7-1.6-.3-3.2-.5-4.8-.8-1.6-.2-3.3-.4-5-.6-3.3-.4-6.7-.9-10.2-1.1-1.7-.2-3.5-.3-5.2-.5s-3.5-.3-5.3-.4-3.5-.2-5.3-.3-3.5-.2-5.3-.2c-3.6-.1-7.1-.1-10.7-.2-3.6.1-7.2.1-10.8.2-1.8 0-3.6.1-5.3.2-1.8.1-3.5.2-5.3.3-1.7.1-3.5.2-5.2.4s-3.5.3-5.2.5c-3.5.2-6.8.7-10.2 1.1-1.7.2-3.3.4-5 .6-1.6.3-3.2.5-4.8.8s-3.2.5-4.7.7c-1.6.3-3.1.6-4.6.9s-3 .6-4.5.8c-1.5.3-2.9.6-4.3 1-1.4.3-2.8.6-4.2.9s-2.7.7-4 1-2.6.6-3.9 1c-1.2.3-2.5.7-3.7 1s-2.4.6-3.5 1c-1.1.3-2.2.7-3.3 1-2.1.6-4.1 1.3-5.9 1.9s-3.5 1.2-5 1.7c-3 1.1-5.3 2-6.9 2.6s-2.4 1-2.4 1 .7-.5 2.2-1.4 3.6-2.2 6.4-3.7 6.3-3.3 10.4-5c1-.4 2.1-.9 3.2-1.4s2.2-.9 3.4-1.4 2.4-.9 3.6-1.4c1.2-.4 2.5-.9 3.8-1.4s2.6-.9 4-1.4c1.4-.4 2.8-.9 4.2-1.3s2.9-.9 4.3-1.3c1.5-.4 3-.8 4.5-1.2s3.1-.8 4.7-1.2c1.6-.3 3.2-.7 4.8-1.1 1.6-.3 3.3-.7 4.9-1.1 1.7-.3 3.4-.6 5.1-.9s3.4-.6 5.1-.9 3.5-.5 5.2-.7c3.5-.4 7.1-1 10.7-1.2 1.8-.1 3.6-.3 5.5-.4 1.8-.1 3.7-.3 5.5-.3 3.6-.1 7.3-.2 11-.3 3.7.1 7.4.2 11 .3 1.8 0 3.7.2 5.5.3s3.6.3 5.4.4c3.6.2 7.2.7 10.7 1.2 1.8.2 3.5.4 5.2.7s3.4.6 5.1.9 3.4.6 5.1.9c1.7.4 3.3.7 4.9 1.1s3.2.7 4.8 1.1 3.1.8 4.7 1.2c1.5.4 3 .8 4.5 1.2s2.9.9 4.3 1.3 2.8.9 4.2 1.3c1.4.5 2.7.9 4 1.4s2.6.9 3.8 1.4 2.4 1 3.6 1.4c1.2.5 2.3.9 3.4 1.4s2.1.9 3.2 1.4c2.1.9 3.9 1.8 5.7 2.6 1.7.8 3.3 1.7 4.7 2.4 2.8 1.5 5 2.8 6.5 3.7 1.8.8 2.6 1.4 2.6 1.4z"/><path d="m25 40.4c5.5.4 8.4 3.4 8.4 6.4 0 6.3-6.5 6.6-8.4 6.8zm-8.2 24.7c0 3.6-.2 6.6-1.1 10.7h10.5c-1.1-4.4-1.2-5.7-1.2-8.9v-7.5c8.6 11.4 9.6 11.6 15.1 16.4h7.5c-4.9-5.9-10.6-12-14.3-18.5 1.9-1 9.1-2.1 9.1-11 0-5.6-3.4-12-16.3-11.8l-10.5.1c.4 1.4 1.1 3.7 1.1 8.6z"/><path d="m53.9 58.4c0-3 2.2-7 5.2-7 2.4 0 4.5 2.6 4.5 7zm15.7 10.1c-3.3 1.5-4.3 2-6.6 2-6.4 0-8.1-5.5-8.3-7.5h15.2c0-3.1.4-5.3 0-7.6-.8-5.5-5.8-9-10.5-9-6.8 0-12.2 5.9-12.2 15.5 0 6.5 4.8 14.9 14 14.9 2.7 0 4.3-1 6.1-1.6z"/><path d="m89 52.2h-6v16.6c0 4 .7 5.4 1.5 6.9l-9.7.1c1.3-2.4 1.6-4.4 1.6-7.4v-16.2l-4.1-.1c1.1-1.4 2.6-5 2.6-5h1.5v-1.7c0-4.2 1.4-11 9.5-11 2.1 0 4.7.7 6.2 1-.6 2.8-.7 2.9-1.1 5.6-.7-1.4-2.3-1.6-4.2-1.6-2.2 0-3.8 2.8-3.8 4.5v3h6z"/><path d="m102.8 46.9c-.3 1.5-.3 2.1-.3 4v1.4c2.9-4.2 4.4-6.1 6.6-6.1 1.2 0 2.1.6 3 1l-.9 6.6c-1-1-1.8-1.5-2.9-1.5-3 0-4.6 3-5.7 4.1v12.6c0 4.2.4 5.1 1.4 6.8h-10.3c1.2-1.8 1.4-2.8 1.4-5.5v-18.4c0-1 0-2.3-.9-5z"/><path d="m121.2 58.4c.4-4.9 2.5-7 4.5-7 2.2 0 4.4 1.8 4.2 7zm15.1 10.1c-3.3 1.5-3.7 2-6 2-6.4 0-8.4-5.5-8.6-7.5l15.2-.3c0-3.1.1-5.3-.3-7.6-.8-5.5-5.5-8.7-10.2-8.7-6.8 0-12.2 5.6-12.2 15.2 0 6.5 3.8 14.9 13.1 14.9 2.7 0 4.6-.7 6.4-1.3z"/><path d="m156 52.8c-1.2-1-3.1-1.3-4.4-1.3-1.7 0-3.6 1.2-3.6 2.6 0 2.2 1.9 3.3 4 4.9 2.9 2.2 4.4 4.6 4.4 8.6 0 4.9-3.3 8.9-9.4 8.9-.7 0-3.4-.3-7-1.4l.1-6.8c2.7 2.4 5 3.2 6.7 3.2s3-1.1 3-2.7c0-1.3-.7-2.5-3.4-4.8-1.7-1.5-5.5-4.3-5.5-8.9 0-3.2 2.8-8.7 9.7-8.7 2.3 0 3.5.4 5.5 1.2v5.2z"/><path d="m180.4 54.1c-.5-.6-2.3-2.7-5.7-2.7-5.9 0-7.6 6.1-7.6 9.7 0 7 6.3 9.4 8.7 9.4 2.5 0 4.7-1 6.1-1.8l-2.8 7.2c-1.5.3-4.2.4-6.3.4-7.1 0-13.4-6.8-13.4-13.6 0-6.1 3.2-16.2 15.9-16.2 2.5 0 4.3.6 5.8.9z"/><path d="m200.1 71.5c-4.9.4-8.7-6.2-8.7-10.4s2.9-10 4.3-10c3 0 8.2 3.5 8.2 10.5 0 6.5-3 9.3-3.8 9.9zm-4.2-25.2c-4.7 1.4-11.6 4.2-11.6 16.3 0 10 7.8 14 13.5 14 3.5 0 14.1-3.6 14.1-16.1-.1-8.6-8.1-14.5-16-14.2z"/></g></svg>
                <span className="styleguide__subtitle" aria-hidden="true">
                  Styleguide
                </span>
              </a>

              <button
                className="styleguide-toggler"
                onClick={() =>
                  document.documentElement.classList.toggle('styleguide-nav--toggled') && refresh({} as never)
                }
              >
                <span className="sr-text">Toggle Menu</span>
                <span aria-hidden="true"></span>
                <span aria-hidden="true"></span>
                <span aria-hidden="true"></span>
                <span aria-hidden="true"></span>
              </button>
            </div>

            <div className="styleguide-nav__wrapper styleguide--styled" data-active-page={currentPage}>
              <nav className="styleguide-nav">
                <h2 className="sr-text">Menu</h2>

                <ul className="styleguide-nav__list">
                  <li className="styleguide-nav__item styleguide-nav--about">
                    <button
                      className="styleguide-nav__link"
                      onClick={() => {
                        return [
                          (currentPage = 'about'),
                          window.innerWidth < $breakpoint &&
                            document.documentElement.classList.remove('styleguide-nav--toggled'),
                          refresh({} as never)
                        ]
                      }}
                    >
                      About
                    </button>
                  </li>
                  <li className="styleguide-nav__item styleguide-nav--tokens">
                    <button
                      className="styleguide-nav__link styleguide-nav__toggler"
                      onClick={() => [
                        (currentPage = 'tokens'),
                        document.documentElement.classList.toggle('styleguide-tokens--toggled'),
                        refresh({} as never)
                      ]}
                    >
                      Design Tokens
                    </button>
                    <ul className="styleguide-nav__sublist">
                      { StyleguideItem('Colors', 'tokens', 'tokens-colors', refresh) }
                      { StyleguideItem('Fonts', 'tokens', 'tokens-fonts', refresh) }
                      { StyleguideItem('Font Styles', 'tokens', 'tokens-styles', refresh) }
                      { StyleguideItem('Font Sizes & Line Heights', 'tokens', 'tokens-sizes-heights', refresh) }
                      { StyleguideItem('Icons', 'tokens', 'tokens-icons', refresh) }
                      { StyleguideItem('Widths', 'tokens', 'tokens-widths', refresh) }
                      { StyleguideItem('Spacings & Gutters', 'tokens', 'tokens-spacings-gutters', refresh) }
                      { StyleguideItem('Transitions', 'tokens', 'tokens-transitions', refresh) }
                    </ul>
                  </li>

                  <li className="styleguide-nav__item styleguide-nav--objects">
                    <button
                      className="styleguide-nav__link styleguide-nav__toggler"
                      onClick={() => [
                        (currentPage = 'objects'),
                        document.documentElement.classList.toggle('styleguide-objects--toggled'),
                        refresh({} as never)
                      ]}
                    >
                      Design Objects
                    </button>

                    <ul className="styleguide-nav__sublist">
                      { StyleguideItem('Typography', 'objects', 'objects-typography', refresh) }
                      { StyleguideItem('Buttons', 'objects', 'objects-buttons', refresh) }
                      { StyleguideItem('Links', 'objects', 'objects-links', refresh) }
                      { StyleguideItem('Lists', 'objects', 'objects-lists', refresh) }
                      { StyleguideItem('Pagination', 'objects', 'objects-pagination', refresh) }
                    </ul>
                  </li>
                  <li className="styleguide-nav__item styleguide-nav--components">
                    <button
                      className="styleguide-nav__link styleguide-nav__toggler"
                      onClick={() => [
                        (currentPage = 'components'),
                        document.documentElement.classList.toggle('styleguide-components--toggled'),
                        refresh({} as never)
                      ]}
                    >
                      Design Components
                    </button>

                    <ul className="styleguide-nav__sublist">
                      { StyleguideItem('Apply Block', 'components', 'components-apply', refresh) }
                      { StyleguideItem('CTA Block', 'components', 'components-cta', refresh) }
                      { StyleguideItem('Colored background', 'components', 'components-blocks-color', refresh) }
                      { StyleguideItem('Download Block', 'components', 'components-download', refresh) }
                      { StyleguideItem('Expand Block', 'components', 'components-expand', refresh) }
                      { StyleguideItem('Featured Content', 'components', 'components-featured-content', refresh) }
                      { StyleguideItem('Footer', 'components', 'components-footer', refresh) }
                      { StyleguideItem('Image gallery block', 'components', 'components-gallery', refresh) }
                      { StyleguideItem('Latest updates', 'components', 'components-updates', refresh) }
                      { StyleguideItem('Link Grid Block', 'components', 'components-linkgrid', refresh) }
                      { StyleguideItem('Link List Block', 'components', 'components-links', refresh) }
                      { StyleguideItem('Media Block', 'components', 'components-media', refresh) }
                      { StyleguideItem('Press Release Block', 'components', 'components-releases', refresh) }
                      { StyleguideItem('Quote Block', 'components', 'components-quote', refresh) }
                      { StyleguideItem('Recruitment Process Block', 'components', 'components-recruit', refresh) }
                      { StyleguideItem('Spacer (custom)', 'components', 'components-spacer', refresh) }
                      { StyleguideItem('Stories Grid Block', 'components', 'components-stories', refresh) }
                      { StyleguideItem('Text Block', 'components', 'components-text', refresh) }
                      { StyleguideItem('Text + Image Block', 'components', 'components-text-image', refresh) }
                      { StyleguideItem('Timeline Block', 'components', 'components-timeline', refresh) }
                    </ul>
                  </li>
                  <li className="styleguide-nav__item styleguide-nav--compositions">
                    <button
                      className="styleguide-nav__link styleguide-nav__toggler"
                      onClick={() => [
                        (currentPage = 'compositions'),
                        document.documentElement.classList.toggle('styleguide-compositions--toggled'),
                        refresh({} as never)
                      ]}
                    >
                      Design Compositions
                    </button>

                    <ul className="styleguide-nav__sublist">
                      { StyleguideItem('Vacancy - Detail page and overview', 'compositions', 'compositions-vacancy-detail', refresh) }
                      { StyleguideItem('Vacancy - Landing', 'compositions', 'compositions-vacancy-landing', refresh) }
                    </ul>
                  </li>
                </ul>
              </nav>

              <div className="styleguide__extra styleguide--styled">
                <a className="styleguide__extra-link" href="https://www.hoppinger.com">
                  by Hoppinger
                </a>
              </div>
            </div>
          </header>

          <div className="styleguide__content">
            {currentPage == 'about'
              ? styleguideAbout.run(__)
              : currentPage == 'guidelines'
              ? styleguideGuidelines.run(__)
              : currentPage == 'tokens'
              ? styleguideTokens.run(__)
              : currentPage == 'objects'
              ? styleguideObjects.run(__)
              : currentPage == 'components'
              ? styleguideComponents.run(__)
              : currentPage == 'compositions'
              ? styleguideCompositions.run(__)
              : null}
          </div>
        </div>

        <svg xmlns="https://www.w3.org/2000/svg" style={{ display: 'none' }} aria-hidden="true">
          <symbol id="image--logo" viewBox="0 0 120 32">
            <path d="m27.5 7.2c0-1.2.9-2.1 2.1-2.1s2.1.9 2.1 2.1-.9 2.1-2.1 2.1c-1.1-.1-2.1-1-2.1-2.1z" />
            <path d="m32.8 8.3c0-.9.7-1.6 1.6-1.6s1.6.7 1.6 1.6-.7 1.6-1.6 1.6-1.6-.8-1.6-1.6z" />
            <path d="m27 4.4-2.1-2.1 2.1-1.7 2.1 1.7z" />
            <path d="m26.4 7.2c0-1.2-.9-2.1-2.1-2.1s-2.1.9-2.1 2.1.9 2.1 2.1 2.1c1.2-.1 2.1-1 2.1-2.1z" />
            <path d="m21.2 8.3c0-.9-.7-1.6-1.6-1.6s-1.6.7-1.6 1.6.7 1.6 1.6 1.6 1.6-.8 1.6-1.6z" />
            <path d="m19.7 11.6c2.4-.5 4.9-.8 7.3-.8 2.5 0 4.9.3 7.3.8v2c-2.4-.4-4.9-.6-7.3-.6s-4.9.2-7.3.6z" />
            <path d="m2.9 24.6h1.5c1.6 0 2.9.7 2.9 2.4 0 1.6-1.2 2.5-2.9 2.5h-1.5zm1.9 6.7c3.5 0 5.6-1.8 5.6-4.3-.1-2-1.8-3.6-3.8-3.6 1.7-.4 2.9-1.8 2.9-3.6 0-2-1.7-3.1-4.2-3.1h-5.3v14.6zm-1.9-12.8h1.5c1.3 0 2.2.6 2.2 1.9-.1 1.4-1.3 2.5-2.7 2.5h-.1-.9z" />
            <path d="m18.9 29.4c-3.1 0-4.2-2.9-4.2-5.7 0-2.7 1.2-5.3 4.2-5.3 2.9 0 4.1 2.6 4.1 5.3.1 2.9-1 5.7-4.1 5.7m0 2.1c4.5 0 7.3-3.4 7.3-7.8.1-4-3.1-7.3-7-7.3-.1 0-.2 0-.3 0-4-.1-7.2 3.1-7.3 7.1v.3c0 4.3 2.8 7.7 7.3 7.7" />
            <path d="m35 29.4c-3.1 0-4.2-2.9-4.2-5.7 0-2.7 1.2-5.3 4.2-5.3 2.9 0 4.2 2.6 4.2 5.3 0 2.9-1.1 5.7-4.2 5.7m0 2.1c4.5 0 7.3-3.4 7.3-7.8 0-4-3.2-7.3-7.2-7.3s-7.3 3.2-7.3 7.2v.1c0 4.4 2.8 7.8 7.2 7.8" />
            <path d="m57.1 31.3h-2.1c-2.8-3.4-5.6-6.7-8.4-10.5v10.5h-2.4v-14.6h2.1c2.8 3.3 5.6 6.7 8.4 10.4v-10.4h2.4z" />
            <path d="m72.7 18.6h-5.8v4h4.8v2h-4.8v4.7h5.8v2h-8.8v-14.6h8.8z" />
            <path d="m77.8 18.6h2.2c3.1 0 4.9 1.9 4.9 4.9 0 4.1-1.8 5.8-5.2 5.8h-1.8zm-2.9-1.9v14.6h4.8c5.2 0 8.3-2.9 8.3-7.7 0-3.5-2.1-6.9-8-6.9z" />
            <path d="m92.6 25.3c.7-1.9 1.4-3.7 2-6 .7 2.3 1.3 4 1.9 6zm1.1-8.8-6 14.6h2.5l1.5-4h5.3l1.4 4h3.3l-5.5-14.6z" />
            <path d="m119.9 31.3h-2.9v-11.4c-1.6 4.1-3.3 7.7-5 11.4h-1.6c-1.6-3.7-3.2-7.3-4.7-11.4v11.4h-2.4v-14.6h3.6c1.5 3.6 3.9 9.3 4.5 11.2.7-2 3.3-7.6 5-11.2h3.4z" />
          </symbol>

          <symbol id="icon--linkedin" viewBox="0 0 20 20">
            <path d="M14.67354,12.21317a2.20436,2.20436,0,0,0-2.07428-2.26562,1.83419,1.83419,0,0,0-2.06372,1.05674,3.60077,3.60077,0,0,0-.19536,1.04414v5.45586H7.68729V7.15624h2.75483l0.13589,1.348h0.05947A3.26232,3.26232,0,0,1,13.57,7.15624c1.988,0,3.77017,1.57358,3.77017,4.458v5.89007H14.67354V12.21317ZM4.11531,5.92645a1.35315,1.35315,0,0,1-1.4261-1.276q-0.00269-.04843-0.0019-0.097A1.364,1.364,0,0,1,4.03766,3.17592q0.05669-.00056.11328,0.00358a1.359,1.359,0,0,1,1.44345,1.269q0.00337,0.05238.00269,0.10491a1.36882,1.36882,0,0,1-1.36,1.37763Q4.17615,5.93148,4.11531,5.92645ZM3.00687,17.50428V7.15624h2.3294v10.348H3.00687v0Z" />
          </symbol>

          <symbol id="icon--twitter" viewBox="0 0 20 20">
            <path d="M17.55338,4.49426a5.60041,5.60041,0,0,0,2.19036-.60044s-0.15034.54692-2.03123,2.27737c0,0,.63329,9.33715-9.01632,11.6239,0,0-4.89373,1.061-8.43993-1.64547,0,0,3.71228.67039,5.80086-1.67411a3.79994,3.79994,0,0,1-3.5462-2.76185,3.18669,3.18669,0,0,0,1.62184-.05587A3.928,3.928,0,0,1,1.1361,7.63966,2.53079,2.53079,0,0,0,2.70289,8.142s-2.7487-2.37221-1.04452-5.32889c0,0,3.68313,4.42,8.248,4.15756A4.05517,4.05517,0,0,1,9.78378,5.9801,3.95224,3.95224,0,0,1,13.70649,2a3.88474,3.88474,0,0,1,2.79635,1.18915,4.44628,4.44628,0,0,0,2.66683-.86428C19.16967,2.32534,19.23119,3.17647,17.55338,4.49426Z" />
          </symbol>

          <symbol id="icon--youtube" viewBox="0 0 20 20">
            <path d="M18.5,12.9753a3.17755,3.17755,0,0,1-3.16279,3.17365H4.66279A3.17755,3.17755,0,0,1,1.5,12.9753V7.02471A3.17755,3.17755,0,0,1,4.66279,3.85107H15.33721A3.17755,3.17755,0,0,1,18.5,7.02471V12.9753ZM8.01064,7.24583v5.87006l5.01136-2.9346Z" />
          </symbol>
        </svg>
      </article>
    </>
  )
})

// Close styleguide menu when pressing the escape key
window.addEventListener('keyup', (e) => {
  if (e.keyCode === 27) {
    document.documentElement.classList.remove('styleguide-nav--toggled')
  }
})

// Close styleguide menu when clicking outside of styleguide header/menu
document.documentElement.addEventListener('click', (e) => {
  const target: HTMLElement = (e.target as HTMLElement) || (e.currentTarget as HTMLElement)

  if (
    target.closest('.styleguide__header') === null &&
    document.documentElement.classList.contains('styleguide-nav--toggled')
  ) {
    document.documentElement.classList.remove('styleguide-nav--toggled')
  }
})

export const styleguide_to = () =>
  ReactDOM.render(
    stateful<{ reload: boolean }>()((s) =>
      div<{ reload: boolean }>()([styleguide.map<{ reload: boolean }>((_) => ({ ...s, reload: !s.reload }))])
    )({ reload: false }).run((_) => {}),
    document.getElementById('react-content')
  )

  const StyleguideItem = ( label: string, page: string, token: string, refresh ) => {
    return(
      <li className="styleguide-nav__item">
        <button
          className="styleguide-nav__link"
          onClick={() => [
            (currentPage = page),
            window.innerWidth < $breakpoint &&
              document.documentElement.classList.remove('styleguide-nav--toggled'),
            refresh({} as never),
            apply_token_to_url(token)
          ]}
        >
          { label }
        </button>
      </li>
    )
  }